import classNames from 'classnames';
import React from 'react';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';

interface Props extends Omit<TextareaAutosizeProps, 'onChange' | 'className'> {
    onChange: (value: string) => void;
    fill?: boolean;
}

export function TextArea({ style: _style, onChange, fill = false, ...props }: Props) {
    const classes = classNames('input-textarea', {
        'input-width--max': fill,
    });

    return (
        <TextareaAutosize
            {...props}
            data-testid="input-textarea"
            className={classes}
            onChange={({ target: { value } }) => {
                onChange(value);
            }}
        />
    );
}
